<template>
  <!-- FOR BRANCH PRICE CHANGE LOG -->
  <!-- <div v-if="$route.name == 'manage_price'" class="">
    <button
      v-if="data.status == 'Submitted' || data.status == 'Initiated'"
      type="button"
      class="btn btn-primary w-50"
      style="cursor: context-menu"
    >
      {{ $t("text.priceManager.submitted") }}
    </button>

    <button
      v-if="data.status == 'Approved'"
      type="button"
      class="btn btn-success w-50"
      style="cursor: context-menu"
    >
      {{ $t("text.cBank.approve") }}
    </button>

    <button
      v-if="data.status == 'Denied'"
      type="button"
      class="btn btn-danger w-50"
      style="cursor: context-menu"
    >
      {{ $t("text.cBank.declined") }}
    </button>
  </div> -->

  <!-- FOR COMPANY AND BRANCH PRICE LOG -->
  <div
    v-if="
      $route.name == 'price_management' ||
      $route.name == 'manage_price' ||
      $route.name == 'group_price_management'
    "
    class=""
  >
    <button
      v-if="data.status == 'Submitted' || data.status == 'Initiated'"
      type="button"
      class="btn btn-outline-primary w-50"
      @click="goToApprovals(data)"
    >
      {{ $t("text.priceManager.approvals") }}
    </button>

    <button
      v-if="data.status == 'Approved'"
      type="button"
      class="btn btn-outline-success w-50"
      @click="goToApprovals(data)"
    >
      {{ $t("text.cBank.approve") }}
    </button>

    <button
      v-if="data.status == 'Denied'"
      type="button"
      class="btn btn-outline-danger w-50"
      @click="goToApprovals(data)"
    >
      {{ $t("text.cBank.declined") }}
    </button>

    <button
      v-if="
        data.isCluster &&
        ($route.name == 'price_management' ||
          $route.name == 'group_price_management')
      "
      type="button"
      class="btn btn-outline-primary w-25 ml-2"
      @click="
        $router.push({
          name:
            $route.name == 'price_management'
              ? 'branch_cluster'
              : 'group_branch_cluster',
          query: {
            entityType: $route.name == 'price_management' ? 'Company' : 'Group',
            Id: data.id,
            branches: data.branchNames,
            companyId: $route.query.companyId,
            branchId: $route.query.branchId,
            groupId: $route.query.groupId,
          },
        })
      "
    >
      {{ $t("text.clickButtons.view") }}
      <i class="fa fa-eye primary-color"> </i>
    </button>

    <button
      v-if="
        !data.isCluster &&
        ($route.name == 'price_management' ||
          $route.name == 'group_price_management')
      "
      type="button"
      style="cursor: not-allowed"
      class="btn btn-outline-secondary w-25 ml-2"
      disabled
    >
      {{ $t("text.clickButtons.view") }}
      <i class="fa fa-eye primary-color"> </i>
    </button>
  </div>

  <!-- APPROVED PRICE BUTTONS -->
  <div v-else class="d-flex justify-content-center">
    <button
      v-if="
        (data.status == 'Pending' && data.userEmail == userInfo.email) ||
        (data.status == 'Pending' && userInfo.roles.includes('Super Admin')) ||
        (data.status == 'Pending' && userInfo.roles.includes('SupportAdmin'))
      "
      type="button"
      class="btn btn-success w-75"
      @click="markApprove(data.id, 'Approve')"
    >
      <span v-if="!loadingApprove">{{ $t("text.omit.approve") }}</span>

      <pulse-loader size="5px" v-if="loadingApprove"></pulse-loader>
    </button>

    <button
      v-if="
        (data.status == 'Pending' && data.userEmail == userInfo.email) ||
        (data.status == 'Pending' && userInfo.roles.includes('Super Admin')) ||
        (data.status == 'Pending' && userInfo.roles.includes('SupportAdmin'))
      "
      type="button"
      class="btn btn-danger ml-3 w-75"
      @click="markDeclined(data.id, 'deny')"
    >
      <span v-if="!loadingDeny">{{ $t("text.priceManager.decline") }}</span>

      <pulse-loader size="5px" v-if="loadingDeny"></pulse-loader>
    </button>

    <button
      v-if="
        data.status == 'Pending' &&
        data.userEmail !== userInfo.email &&
        (!userInfo.roles.includes('Super Admin') ||
          !userInfo.roles.includes('SupportAdmin'))
      "
      type="button"
      class="btn btn-warning w-100"
      style="cursor: not-allowed"
    >
      {{ $t("text.priceManager.unauthorized") }}
    </button>

    <button
      v-if="data.status == 'Approved'"
      type="button"
      class="btn btn-success w-100"
      style="cursor: not-allowed"
    >
      {{ $t("text.cBank.approve") }}
    </button>

    <button
      v-if="data.status == 'Denied'"
      v-b-popover.click.left="{
        title: $t('text.priceManager.reasonFor'),
        content: data.note,
        variant: 'danger',
      }"
      type="button"
      class="btn btn-danger w-100"
      style="cursor: pointer"
    >
      {{ $t("text.cBank.declined") }}
      <i class="fa fa-eye ml-2"> </i>
    </button>
  </div>
</template>

<script>
import configObject from "@/config";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  data() {
    return {
      data: {},
      userInfo: JSON.parse(localStorage.getItem("userDetails")),
      loadingDeny: false,
      loadingApprove: false,
      reason: "",
    };
  },
  components: {
    PulseLoader,
  },
  mounted() {
    // console.log(this.userInfo.email);
  },
  methods: {
    markDeclined: function (id, status) {
      this.$eventHub.$emit("_markDeclined", id, status);
    },

    goToApprovals(data) {
      this.$router.push({
        name:
          this.$route.name == "price_management"
            ? "approve_price"
            : this.$route.name == "manage_price"
            ? "branch_approve_price"
            : "group_approve_price",
        query: {
          entityType:
            this.$route.name == "price_management"
              ? "Company"
              : this.$route.name == "manage_price"
              ? "Branch"
              : "Group",
          Id: data.id,
          branches: data.branchNames,
          companyId: this.$route.query.companyId,
          branchId: this.$route.query.branchId,
          groupId: this.$route.query.groupId,
        },
      });
    },

    markApprove(id, status) {
      let remove;

      if (status == "Approve") {
        remove = confirm(this.$t("text.priceManager.approveWarn"));
      } else {
        remove = confirm(this.$t("text.priceManager.declineWarn"));
      }

      if (!remove) {
        return;
      }

      if (status == "Approve") {
        this.loadingApprove = true;
      } else {
        this.loadingDeny = true;
      }

      const data = {
        status: status,
        reason: this.reason,
      };

      this.axios
        .post(
          `${configObject.apiBaseUrl}/Approval/UpdateStatus/${id}`,
          data,
          configObject.authConfig()
        )
        .then((res) => {
          if (status == "Approve") {
            this.loadingApprove = false;
          } else {
            this.loadingDeny = false;
          }

          this.$toast.open({
            message:
              status == "Approve"
                ? this.$t("text.priceManager.approveSuccess")
                : this.$t("text.priceManager.declineSuccess"),
            type: "success",
            duration: 4000,
          });
          this.reason = "";
          this.$eventHub.$emit("getPriceChange");
        })
        .catch((error) => {
          if (status == "Approve") {
            this.loadingApprove = false;
          } else {
            this.loadingDeny = false;
          }

          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 4000,
          });

          this.reason = "";
        });
    },
  },
};
</script>
